
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/restaurants",
      function () {
        return require("private-next-pages/restaurants/index.tsx");
      }
    ]);
  